/*=========================================================================================
  File Name: moduleCustomerActions.js
  Description: Customer Module Actions
==========================================================================================*/

import customerCardGql from "@/http/requests/card/customer_gql";

export default {
	setCustomersSearchQuery({ commit }, query) {
		commit("SET_CUSTOMERS_SEARCH_QUERY", query);
	},

	fetchCustomersManagement({ commit }, payload) {
		return new Promise((resolve, reject) => {
			customerCardGql
				.fetchCustomers(payload)
				.then(response => {
					commit("SET_CUSTOMERS", response.customers);
					commit("SET_TOTAL_CUSTOMERS", response.total);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	addCustomer({ state, commit }, customer) {
		return new Promise((resolve, reject) => {
			customerCardGql
				.addCustomer(customer)
				.then(response => {
					commit("ADD_CUSTOMER", response);
					commit("SET_TOTAL_CUSTOMERS", state.total + 1);

					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	updateCustomer({ commit }, customer) {
		return new Promise((resolve, reject) => {
			customerCardGql
				.updateCustomer(customer)
				.then(response => {
					commit("UPDATE_CUSTOMER", response);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	deleteCustomer({ state, commit }, customerId) {
		return new Promise((resolve, reject) => {
			customerCardGql
				.deleteCustomer(customerId)
				.then(response => {
					commit("DELETE_CUSTOMER", customerId);
					commit("SET_TOTAL_CUSTOMERS", state.total - 1);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},
	getCustomerDebts({ commit }, payload) {
		return new Promise((resolve, reject) => {
			customerCardGql
				.getCustomerDebtPaginations(payload)
				.then(response => {
					commit("SET_CUSTOMER_DEBTS", response.customer_debts);
					commit("SET_TOTAL_CUSTOMER_DEBTS", response.total);

					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},
	getCustomerYtes({ commit }, payload) {
		return new Promise((resolve, reject) => {
			customerCardGql
				.getCustomerYtesPaginations(payload)
				.then(response => {
					// commit("SET_CUSTOMER_DEBTS", response.customer_debts);
					// commit("SET_TOTAL_CUSTOMER_DEBTS", response.total);

					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},
	createCustomerDebt({ commit }, payload) {
		return new Promise((resolve, reject) => {
			customerCardGql
				.createDebt(payload)
				.then(response => {
					commit("ADD_CUSTOMER_DEBT", response);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},
	saveCustomerTTYT({ commit }, payload) {
		return new Promise((resolve, reject) => {
			customerCardGql
				.saveTTYT(payload)
				.then(response => {
					commit("ADD_CUSTOMER_DEBT", response);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},
	fetchCustomerShowProducts({ commit }, payload) {
		return new Promise((resolve, reject) => {
			customerCardGql
				.fetchShowProducts(payload)
				.then(response => {
					commit("SET_SHOW_PRODUCTS", response.products);
					commit("SET_TOTAL_SHOW_PRODUCTS", response.total);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},
	exportCustomerData({ commit }, payload) {
		return new Promise((resolve, reject) => {
			customerCardGql
				.exportCustomerData(payload)
				.then(response => {
					commit("SET_CUSTOMER_DEBTS_REPORT_EXCEL", response);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},
	getCustomerDetail({ commit }, payload) {
		return new Promise((resolve, reject) => {
			customerCardGql
				.getCustomerDetail(payload)
				.then(response => {
					commit("UPDATE_CUSTOMER", response.customer);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},
	increaseTotalDebts({ commit }) {
		commit("INCREASE_TOTAL_DEBTS");
	},
	getCustomerAcccessableFields({ commit }) {
		return new Promise((resolve, reject) => {
			customerCardGql
				.getCustomerAcccessableFields()
				.then(response => {
					commit("UPDATE_CUSTOMER_ACCCESSABLE_FIELDS", response.acccessable_fields);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	fetchPipelines({ commit }, payload) {
		return new Promise((resolve, reject) => {
			customerCardGql
				.pipelines(payload)
				.then(response => {
					commit("SET_PIPELINES", response.pipelines);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},
	addPipeline({ commit }, payload) {
		return new Promise((resolve, reject) => {
			customerCardGql
				.addPipeline(payload)
				.then(response => {
					commit("ADD_PIPELINE", response);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},
	updatePipeline({ commit }, payload) {
		return new Promise((resolve, reject) => {
			customerCardGql
				.updatePipeline(payload)
				.then(response => {
					commit("UPDATE_PIPELINE", response);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},
	deletePipeline({ commit }, payload) {
		return new Promise((resolve, reject) => {
			customerCardGql
				.deletePipeline(payload)
				.then(response => {
					commit("DELETE_PIPELINE", payload.id);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},
	sortPipeline({ commit }, payload) {
		return new Promise((resolve, reject) => {
			customerCardGql
				.sortPipeline(payload)
				.then(response => {
					commit("SET_PIPELINES", payload.pipelines);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},
	addProduct({ commit }, payload) {
		return new Promise((resolve, reject) => {
			customerCardGql
				.addProduct(payload)
				.then(response => {
					commit("ADD_PRODUCT", response);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},
	updateProduct({ commit }, payload) {
		return new Promise((resolve, reject) => {
			customerCardGql
				.updateProduct(payload)
				.then(response => {
					commit("UPDATE_PRODUCT", response);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},
	deleteProduct({ commit }, payload) {
		return new Promise((resolve, reject) => {
			customerCardGql
				.deleteProduct(payload)
				.then(response => {
					commit("DELETE_PRODUCT", payload.id);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},
	getProductItem({ commit }, id) {
		return new Promise((resolve, reject) => {
			customerCardGql
				.getProductItem(id)
				.then(response => {
					commit("UPDATE_PRODUCT", response);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	}
};
